<template>
    <div class="vue-dropdown-filter" :class="{ 'is-disabeld': disabled }" v-show="hasOptions === true">
        <v-select
            v-if="!isObject"
            v-model="selectedValue" :options="options" :disabled="! hasOptions || disabled" :label="label" :placeholder="placeholder" @input="handleInput"></v-select>

        <v-select
            v-if="isObject"
            v-model="selectedValue"
            :options="options"
            :disabled="! hasOptions || disabled"
            label="label"
            :placeholder="placeholder"
            @input="handleInput"
            :reduce="option => option.value"
        ></v-select>
    </div>
</template>

<script>
import baseFilter from '../mixins/baseFilter';

export default {
    name: "OccasionDropdownFilter",

    mixins: [baseFilter],

    props: {
        disabled: {
            type: Boolean,
            default: false
        },

        options: {
            type: Array,
            default: () => []
        },

        placeholder: {
            type: String
        },

        label: {
            type: String,
            default: 'name'
        }
    },

    data() {
        return {
            selectedValue: null,
        }
    },

    computed: {
        isObject() {
            return (this.filterKey === 'field_merk');
        },

        hasOptions() {
            return !_.isEmpty(this.options);
        },

        localStorageValue() {
            let localStorageFilters = localStorage.getItem('appliedFilters');

            if (lodash.isNil(localStorageFilters)) {
                return null;
            }

            localStorageFilters = JSON.parse(localStorage.getItem('appliedFilters'));

            if (lodash.isNil(localStorageFilters) || _.isEmpty(localStorageFilters)) {
                return null;
            }

            let localStorageEntry = _.find(localStorageFilters, {'key': this.filterKey});

            if (lodash.isNil(localStorageEntry) || lodash.isNil(localStorageEntry.value) || _.isEmpty(localStorageEntry)) {
                return null;
            }

            return localStorageEntry.value;
        }
    },

    mounted() {
        this.eventBus.$on('core-filter-changed', () => this.selectedValue = null);

        this.eventBus.$on('reset-filters', () => this.selectedValue = null );

        if (! lodash.isNil(this.localStorageValue)) {
            this.selectedValue = this.localStorageValue;
        }
    },

    methods: {
        handleInput(payload) {
            if (lodash.isNil(payload)) {
                this.eventBus.$emit('dropdown-emptied', this.filterKey);
                return;
            }

            this.eventBus.$emit('dropdown-changed', {
                filterKey: this.filterKey,
                value: payload,
                type: 'dropdown'
            });
        }
    }
}
</script>
